import styled from '@emotion/styled'
import { ActionCards } from 'components/actions/ActionCards'
import { colors } from 'utils/colors'

export const SActionCards = styled(ActionCards)`
  & svg {
    width: 2rem;
    height: 2rem;
    color: ${colors.gray[500]};
  }
`
